import moment from 'moment'
import { parseJson } from '@zero-org/utils'
import { Modal, message } from 'ant-design-vue'
import { MsgType, Type, Platform, CustomerType, UserType, ErrorType } from './const'
import CountDown from '@/utils/count-down'

interface Options {
  question: string,
  listeners?: any
}

class Chat {
  ws: any = null
  wsUrl = ''
  options: Options = {
    question: ''
  }
  listeners: any = {}
  sessionId: number | null = null

  countDownA = new CountDown(60 * 3, 0)
  countDownB = new CountDown(60 * 5, 0)

  constructor(wsUrl: string) {
    this.wsUrl = wsUrl
  }

  init(options: Options) {
    this.listeners = options.listeners
    this.options = options
    this.openWs()
  }

  openWs() {
    if (!navigator.onLine) {
      this.listeners.onError && this.listeners.onError('network status offline!')
      return
    }

    if (this.ws && this.ws.readyState !== WebSocket.CLOSED) {
      return
    }

    // 建立websocket连接
    this.ws = new WebSocket(this.wsUrl)
    this.ws.onopen = this.onOpen.bind(this)
    this.ws.onmessage = this.onMessage.bind(this)
    this.ws.onclose = this.onClose.bind(this)
    this.ws.ononerror = this.onError.bind(this)
  }

  onOpen() {
    const questionList = [this.options.question]
    this.sentInit(questionList)

    this.listeners.onOpen && this.listeners.onOpen()
  }

  onMessage({data}: any) {
    const resData = parseJson(data)
    const { msgType } = resData
    switch (msgType) {
      case MsgType.System:
        this.handleSystemMsg(resData)
        break;
      case MsgType.Text:
        this.countDown()
        this.handleTextMsg(resData)
        break;
      case MsgType.Image:
        this.countDown()
        this.handleImageMsg(resData)
        break;
      case MsgType.Satisfy:
        this.countDown()
        this.handleSatisfy(resData)
        break;
      case ErrorType.NoAgent:
        resData.content = '人工客服坐席正忙，请稍后连接...'
        this.handleErrorMsg(resData)
        break;
      case ErrorType.Queue:
        this.handleQueueMsg(resData)
        break;
      case '3002':
        resData.content = '人工客服坐席已退出'
        this.handleClosed(resData)
        break;
      case '3003':
        resData.content = `因目前排队人数较多，预计排队时间较长，您可登陆<a href='http://120.221.95.60:9000/qdrsznwd/index' style='color:red;'>我局智能查询系统</a>进行自助服务或拨打<a href='http://hrss.qingdao.gov.cn/fwdh.shtml' target='_blank' style='color:red;'>相关业务部门电话</a>进行咨询`
        this.handleErrorMsg(resData)
        break;
      case '6001':
        this.handleTipMsg(resData)
        break;
      case '6002':
        this.handleClosed(resData)
        break;
      default:
        break;
    }
  }

  onClose(e: any) {
    this.countDownA && this.countDownA.clearTimer()
    this.countDownB && this.countDownB.clearTimer()
    this.listeners.onClose && this.listeners.onClose()
  }

  onError(e: any) {
    this.countDownA && this.countDownA.clearTimer()
    this.countDownB && this.countDownB.clearTimer()
    const json = {
      content: '人工客服全忙'
    }
    this.listeners.onTextMsg && this.listeners.onTextMsg(json)
  }

  /**
   * 处理系统消息
   * @param resData 
   */
  handleSystemMsg(resData: any) {
    const { content } = resData
    if (content.startsWith('已接入人工坐席')) {
      this.listeners.onSuccess && this.listeners.onSuccess(resData)
    }
    this.listeners.onSystemMsg && this.listeners.onSystemMsg(resData)
  }

  handleTextMsg(resData: any) {
    this.listeners.onTextMsg && this.listeners.onTextMsg(resData)
  }

  handleImageMsg(resData: any) {
    this.listeners.onImageMsg && this.listeners.onImageMsg(resData)
  }

  handleErrorMsg(resData: any) {
    this.listeners.onFailed && this.listeners.onFailed(resData)
    this.closeWs()
  }

  /**
   * 处理排队信息
   */
  handleQueueMsg(resData: any) {
    this.listeners.onQueued && this.listeners.onQueued(resData)
  }

  handleTipMsg(resData: any) {
    Modal.confirm({
      title: resData.content,
      okText: '是',
      cancelText: '否',
      onOk: () => {
        message.info('请您继续耐心等待')
      },
      onCancel: () => {
        this.listeners.onReleased && this.listeners.onReleased()
        this.closeWs()
      }
    })
  }

  handleClosed(resData: any) {
    this.listeners.onReleased && this.listeners.onReleased(resData)
    this.closeWs()
  }

  handleSatisfy(resData: any) {
    this.listeners.onSatisfaction && this.listeners.onSatisfaction(resData)
  }

  sentInit(question: string[]) {
    this.sessionId = new Date().getTime() + Math.floor(Math.random() * 1000)
    const json = {
      // 渠道id
      platformId: Platform.Website,
      // 会话id
      sessionid: this.sessionId,
      customerType: CustomerType.User,
      userId: '1',
      userName: '游客',
      idCard: '1',
      phone: '',
      userType: UserType.Person,
      addreass: '',
      question,
      reqTime: moment(new Date()).format('YYYYMMDDHHmmss'),
      token: '5nA7477VGjlRxP0rAuU01AwmekM4ql//VHg4/hm4LQo=',
      msgType: MsgType.Init,
      person: Type.User
    }

    this.ws && this.ws.send(JSON.stringify(json))
  }

  /**
   * 发送文本消息
   * @param text 
   */
  sendTextMsg(text: string) {
    const json = {
      // 渠道id
      platformId: Platform.Website,
      // 会话id
      sessionid: this.sessionId,
      //接入类型（1、匿名、2、用户）
      uuid: 1,
      seatid: '1',
      fromName: '游客',
      msgType: '2000',
      content: text,
      reqTime: moment(new Date()).format('YYYYMMDDHHmmss'),
      person: Type.User
    }
    this.ws && this.ws.send(JSON.stringify(json))
    this.countDown()
  }

  getPageCount(base64: string, limit: number = 60000) {
    const length = base64.length
    if (length % limit) {
      return parseInt(String(length / limit)) + 1
    } else {
      return length / limit
    }
  }

  sendImageMsg(base64: string) {
    try {
      const limit = 5000
      base64 = base64.replace(/data([\s\S]+\,)?/, '')
  
      const pageCount = this.getPageCount(base64, limit)
  
      for (let i = 0; i < pageCount; i++) {
        const content = base64.substr(i * limit, limit)
        const json = {
          // 渠道id
          platformId: Platform.Website,
          // 会话id
          sessionid: this.sessionId,
          //接入类型（1、匿名、2、用户）
          uuid: 2,
          seatid: '1',
          fromName: '游客',
          msgType: '2005',
          content,
          filetype: 'jpeg',
          reqTime: moment(new Date()).format('YYYYMMDDHHmmss'),
          person: Type.User,
          page: i + 1,
          pagecount: pageCount
        }

        this.ws && this.ws.send(JSON.stringify(json))
        this.countDown()
      }
    } catch (error) {
      console.error(error)
    }
  }

  sendSatisfy(content: any, cb: any) {
    const json = {
      // 渠道id
      platformId: Platform.Website,
      // 会话id
      sessionid: this.sessionId,
      //接入类型（1、匿名、2、用户）
      uuid: 1,
      seatid: '1',
      fromName: '游客',
      // 4001市民断开评价，4002咨询员主动评价
      msgType: '4002',
      content,
      reqTime: moment(new Date()).format('YYYYMMDDHHmmss'),
      person: Type.User
    }

    this.ws && this.ws.send(JSON.stringify(json))
    this.countDown()
    
    cb && cb()
  }

  countDown() {
    if (this.countDownA) {
      this.countDownA.clearTimer()
      this.countDownA.start(() => {
        const json = {
          content: '您已经3分钟没有提问了，如果再不提问2分钟后将自动断开连接'
        }
        this.listeners.onTextMsg && this.listeners.onTextMsg(json)
      })
    }

    if (this.countDownB) {
      this.countDownB.clearTimer()
      this.countDownB.start(() => {
        const json = {
          content: '您已经5分钟没有提问了，连接已断开'
        }
        this.listeners.onTextMsg && this.listeners.onTextMsg(json)
        this.releaseChat()
        setTimeout(() => {
          this.closeWs()
        }, 200)
      })
    }
  }

  closeWs() {
    this.ws && this.ws.close()
    // 重置数据
    this.ws = null
    this.options = {
      question: ''
    }
    this.listeners = {}
    this.sessionId = null
  }

  releaseChat() {
    const json = {
      // 渠道id
      platformId: Platform.Website,
      // 会话id
      sessionid: this.sessionId,
      //接入类型（1、匿名、2、用户）
      uuid: 1,
      seatid: '1',
      fromName: '游客',
      msgType: '5001',
      content: '5003',
      reqTime: moment(new Date()).format('YYYYMMDDHHmmss'),
      person: Type.User
    }

    this.ws && this.ws.send(JSON.stringify(json))
  }
}

export default Chat